/* eslint-disable @typescript-eslint/no-unused-vars */
import { Pagination } from "@mui/material";
import React from "react";

import * as Styles from "./styles";

export interface PaginationInterfaceSend {
  PaginaAtual: number | undefined;
  TotalItensRetorno: number | undefined;
}

interface ChildComponentProps {
  onData: (data: PaginationInterfaceSend) => void;
  countTotalPagination: number;
  isLoading?: boolean;
}

export function FooterTableEmpreendimentosRevenda(
  props: PaginationInterfaceSend & ChildComponentProps
) {
  const [tableParams, setTableParams] = React.useState<PaginationInterfaceSend>(
    {
      PaginaAtual: props.PaginaAtual,
      TotalItensRetorno: props.TotalItensRetorno,
    }
  );

  React.useEffect(() => {
    props.onData(tableParams);
  }, [tableParams]);

  return (
    <Styles.ContainerPagination>
      {props.isLoading ? (
        <></>
      ) : (
        <>
          <Styles.Arrows>
            <Pagination
              color="standard"
              count={props.countTotalPagination}
              page={props.PaginaAtual}
              onChange={(event: React.ChangeEvent<unknown>, value: any) => {
                setTableParams({
                  ...tableParams,
                  PaginaAtual: value,
                });
              }}
              showFirstButton
              size="small"
              variant="outlined"
              shape="circular"
              showLastButton
            />
          </Styles.Arrows>
          <Styles.Arrows>
            <div>Itens por página</div>
            <Styles.SelectStyled
              displayEmpty
              color="secondary"
              variant="outlined"
              labelId="pages"
              id="pages"
              value={tableParams.TotalItensRetorno}
              label="Pages"
              onChange={(event: any) => {
                setTableParams({
                  PaginaAtual: 1,
                  TotalItensRetorno: event.target.value,
                });
              }}
            >
              <Styles.MenuItemStyled value={10}>10</Styles.MenuItemStyled>
              <Styles.MenuItemStyled value={20}>20</Styles.MenuItemStyled>
              <Styles.MenuItemStyled value={50}>50</Styles.MenuItemStyled>
              <Styles.MenuItemStyled value={100}>100</Styles.MenuItemStyled>
            </Styles.SelectStyled>
          </Styles.Arrows>
        </>
      )}
    </Styles.ContainerPagination>
  );
}
